module.exports = __webpack_public_path__ + "img/bn-solutions-bg-sm.1ba6a156.svg";